export default __webpack_public_path__ + "static/media/thumbnail_image005.b4e0be4f.png";